import { useIonLoading } from '@ionic/react'
import { useSelector } from 'react-redux'
import { OPERATION_TYPE, URL } from '../../const/constants'
import { useAppContext } from '../../context/AppContext'
import useMessages from '../../hooks/useMessages'
import { createOBDValidationFlowId } from '../../services/api/portabilidad-api'
import Button from '../Button'
import { validateMaxLines } from '../../services/api/preactivacion'

interface Props {
  storeForm: string
  error?: boolean
  label: string
}

const OBDValidationButton = ({ storeForm, label, error }: Props) => {
  const procedure: string = location.pathname.split('/')[2]
  const { documentType, documentNumber } = useSelector((state: any) => state[storeForm])
  const simData = useSelector((state: any) => state.simData)
  const initializedDate = useSelector((state: any) => state.initializedDate)
  const validity = Object.values({ documentType, documentNumber }).some((value) => !value)
  const { user, settings }: any = useAppContext()

  const [present, dismiss] = useIonLoading()
  const { toastMessage } = useMessages()

  const handleValidateLines = async () => {
    if (settings.country === 'PY') {
      const document = documentType === 'EXTA' ? 'DNI' : documentType
      const body = {
        tipoDoc: document,
        nroDoc: documentNumber
      }
      const response = await validateMaxLines(body);
      const status = response?.status;

      if (status === 200) {
        if (response?.data?.message === "OK") {
          await onContinue();
        } else {
          dismiss();
          location.href = '/procedures/preactivaciones/error-lineas-activas';
        }
      } else if ([500, 400, 404].includes(status)) {
        toastMessage(
          `No se puede validar la cantidad de líneas del cliente`,
          3000,
          'bottom',
          'error'
        );
        dismiss();
      }
    } else {
      await onContinue();
    }
  }

  const onContinue = async () => {
    const request = {
      documentType,
      documentNumber,
      operationType: OPERATION_TYPE[procedure],
      user: user.posNumber
    }

    try {
      present({ message: `Validando datos... <br/> Esperá por favor.` })
      const response = await createOBDValidationFlowId(request)

      if (!response?.success) throw new Error('No se pudo crear una validación.')
      localStorage.setItem('preOBDData', JSON.stringify({ ...request, initializedDate }))
      if (procedure === URL.activaciones) localStorage.setItem('simData', JSON.stringify(simData))
      location.href = `${settings.obd.url}/id?f=${response?.response?.flowId}`
      dismiss()
    } catch (errors) {
      console.log(errors)
      toastMessage(
        `No pudimos crear una validación.
      \n
        Comunicate con soporte.`,
        3000,
        'bottom',
        'error'
      )
      dismiss()
    }
  }

  return (
    <Button
      id="chip-form-continue"
      className="submit-button btn-margin-down btn-margin-top"
      label={label}
      landing={error}
      validity={validity}
      handleSubmit={handleValidateLines}
    />
  )
}

export default OBDValidationButton
